/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ReferralReasonType;

(function (ReferralReasonType) {
  ReferralReasonType["MANUAL"] = "manual";
  ReferralReasonType["API"] = "api";
})(ReferralReasonType || (ReferralReasonType = {}));